import { useFormik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SelectForms from "src/components/user/select-forms-component";
import * as list from "src/core/statics/form-data/form-data";
import { schoolRegisterValidationSchema2 } from "src/components/user/validation/school-register-form-validation";
import SelectFormsSmaller from "src/components/user/select-forms-smaller-component";

function AnotherInfoContainer() {
  const { i18n, t } = useTranslation();
  const [showCountryOptions, setShowCountryOptions] = useState<boolean>(false);
  const [isCountrySelected, setIsCountrySelected] = useState<boolean>(false);
  const [country, setCountry] = useState("");

  const [showCityOptions, setShowCityOptions] = useState<boolean>(false);
  const [isCitySelected, setIsCitySelected] = useState<boolean>(false);
  const [city, setCity] = useState("");

  const [showDistrictOptions, setShowDistrictOptions] = useState<boolean>(false);
  const [isDistrictSelected, setIsDistrictSelected] = useState<boolean>(false);
  const [district, setDistrict] = useState("");

  type InitialValuesType = {
    country: string;
    city: string;
    district: string;
    contactPersonName: string;
    phoneNumber: string;
    ministerialNumber: string;
    postBox: string;
    zipCode: string;
    commercialRegister: string;
  };

  const initialValues: InitialValuesType = {
    country: "",
    city: "",
    district: "",
    contactPersonName: "",
    phoneNumber: "",
    ministerialNumber: "",
    postBox: "",
    zipCode: "",
    commercialRegister: "",
  };

  const removeSymbolsFromInput = (
    evt: React.KeyboardEvent<HTMLInputElement>
  ) => {
    ["e", "E", "+", "-", "."].includes(evt.key) && evt.preventDefault();
  };

  const handleClickOnCountryOption = (item: string) => {
    setCountry(item);
    setIsCountrySelected(true);
    setShowCountryOptions(false);
  };

  const handleClickOnCityOption = (item: string) => {
    setCity(item);
    setIsCitySelected(true);
    setShowCityOptions(false);
  };

  const handleClickOnDistrictOption = (item: string) => {
    setDistrict(item);
    setIsDistrictSelected(true);
    setShowDistrictOptions(false);
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useFormik({
    initialValues: initialValues,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: schoolRegisterValidationSchema2,
    onSubmit: async () => {
      handleSubmit();
    },
  });

  return (
    <div className="flex flex-col items-center justify-center rounded-lg font-ar bg-white max-w-[717px] w-[calc(60vw)] gap-4 h-fit py-8 mobile:py-0 mobile:w-[calc(100vw-32px)] mobile:h-auto drop-shadow-[0_0px_20px_rgba(0,0,0,0.05)]">
      <div className="flex flex-col gap-2 mobile:p-3">
        <p className="flex flex-row items-start mobile:text-mint-500 mobile:text-lg mobile:font-medium">
          {t("schoolInfo.container.otherInformation")}
        </p>
        <SelectForms
          currrentValue={
            country === ""
              ? i18n.language === "ar"
                ? list.countrySchoolForm[0]
                : list.countrySchoolFormEng[0]
              : country
          }
          showOptions={showCountryOptions}
          isSelected={isCountrySelected}
          onClickOnDropDown={() => setShowCountryOptions(!showCountryOptions)}
          onClickOnOption={(item) => handleClickOnCountryOption(item)}
          label={t("forms.component.country")}
          options={
            i18n.language === "ar"
              ? list.countrySchoolForm
              : list.countrySchoolFormEng
          }
          validation={
            <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
              {errors.country}
            </p>
          }
          validationErrors={errors.country}
          validationTouched={touched.country}
        />
        <div className="flex flex-row mobile:flex-col gap-4">
          <SelectFormsSmaller
            currrentValue={
              city === ""
                ? i18n.language === "ar"
                  ? list.citySchoolForm[0]
                  : list.citySchoolFormEng[0]
                : city
            }
            showOptions={showCityOptions}
            isSelected={isCitySelected}
            onClickOnDropDown={() => setShowCityOptions(!showCityOptions)}
            onClickOnOption={(item) => handleClickOnCityOption(item)}
            label={t("forms.component.city")}
            options={
              i18n.language === "ar"
                ? list.citySchoolForm
                : list.citySchoolFormEng
            }
            validation={
              <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                {errors.city}
              </p>
            }
            validationTouched={touched.city}
            validationErrors={errors.city}
          />
          <SelectFormsSmaller
            currrentValue={
              district === ""
                ? i18n.language === "ar"
                  ? list.districtSchoolForm[0]
                  : list.districtSchoolFormEng[0]
                : district
            }
            showOptions={showDistrictOptions}
            isSelected={isDistrictSelected}
            onClickOnDropDown={() =>
              setShowDistrictOptions(!showDistrictOptions)
            }
            onClickOnOption={(item) => handleClickOnDistrictOption(item)}
            label={t("forms.component.district")}
            options={
              i18n.language === "ar"
                ? list.districtSchoolForm
                : list.districtSchoolFormEng
            }
            validation={
              <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                {errors.district}
              </p>
            }
            validationErrors={errors.district}
            validationTouched={touched.district}
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
            {t("schoolRegisterFormStep2.component.contactPersonName")}
          </label>
          <input
            value={values.contactPersonName}
            onChange={handleChange}
            onBlur={handleBlur}
            id="contactPersonName"
            type="text"
            className={`${
              touched.contactPersonName && errors.contactPersonName
                ? "border-secondary-50 focus:border-secondary-50"
                : "border-zinc400 focus:border-mint-500"
            } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
            placeholder={`${t("placeholder.contactPersonName.nameExample")}`}
          ></input>
          {touched.contactPersonName && errors.contactPersonName && (
            <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
              {errors.contactPersonName}
            </p>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
            {t("schoolRegisterFormStep2.component.phoneNumber")}
          </label>
          <input
            onKeyDown={removeSymbolsFromInput}
            value={values.phoneNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            id="phoneNumber"
            type="number"
            className={`${
              touched.phoneNumber && errors.phoneNumber
                ? "border-secondary-50 focus:border-secondary-50"
                : "border-zinc400 focus:border-mint-500"
            } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
            placeholder={i18n.language === "ar" ? "********05" : "05********"}
          ></input>
          {touched.phoneNumber && errors.phoneNumber && (
            <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
              {errors.phoneNumber}
            </p>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
            {t("schoolRegisterFormStep2.component.ministerialNumber")}
          </label>
          <input
            onKeyDown={removeSymbolsFromInput}
            value={values.ministerialNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            id="ministerialNumber"
            type="number"
            className={`${
              touched.ministerialNumber && errors.ministerialNumber
                ? "border-secondary-50 focus:border-secondary-50"
                : "border-zinc400 focus:border-mint-500"
            } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
            placeholder={"12242421"}
          ></input>
          {touched.ministerialNumber && errors.ministerialNumber && (
            <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
              {errors.ministerialNumber}
            </p>
          )}
        </div>
        <div className="flex flex-row justify-center mobile:flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
              {t("schoolRegisterFormStep2.component.postBox")}
            </label>
            <input
              onKeyDown={removeSymbolsFromInput}
              value={values.postBox}
              onChange={handleChange}
              onBlur={handleBlur}
              id="postBox"
              type="number"
              className={`${
                touched.postBox && errors.postBox
                  ? "border-secondary-50 focus:border-secondary-50"
                  : "border-zinc400 focus:border-mint-500"
              } w-[204px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
              placeholder={"1111"}
            ></input>
            {touched.postBox && errors.postBox && (
              <p className="w-44 text-base mobile:text-xs font-arMedium text-secondary-50">
                {errors.postBox}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
              {t("schoolRegisterFormStep2.component.zipCode")}
            </label>
            <input
              onKeyDown={removeSymbolsFromInput}
              value={values.zipCode}
              onChange={handleChange}
              onBlur={handleBlur}
              id="zipCode"
              type="number"
              className={`${
                touched.zipCode && errors.zipCode
                  ? "border-secondary-50 focus:border-secondary-50"
                  : "border-zinc400 focus:border-mint-500"
              } w-[204px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
              placeholder={"1111"}
            ></input>
            {touched.zipCode && errors.zipCode && (
              <p className="w-44 text-base mobile:text-xs font-arMedium text-secondary-50">
                {errors.zipCode}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnotherInfoContainer;
